import { render, staticRenderFns } from "./changePhone.vue?vue&type=template&id=63df03c4&scoped=true&"
import script from "./changePhone.vue?vue&type=script&lang=js&"
export * from "./changePhone.vue?vue&type=script&lang=js&"
import style0 from "./changePhone.vue?vue&type=style&index=0&id=63df03c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df03c4",
  null
  
)

export default component.exports